import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-headset",
  "use": "icon-headset-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-headset\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 42.667c-212.053 0-384 171.946-384 384v298.666c0 70.614 57.387 128 128 128h128V512H213.333v-85.333C213.333 261.76 347.093 128 512 128s298.667 133.76 298.667 298.667V512H640v341.333h128c70.613 0 128-57.386 128-128V426.667c0-212.054-171.947-384-384-384z\" p-id=\"12782\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-sprite-loader/lib/loader.js?{"symbolId":"icon-[name]"}!./src/assets/icons/svg/headset.svg
// module id = ywog
// module chunks = 1